import { api } from "../api";

export async function renderTiers(el: HTMLElement): Promise<void> {
  el.innerHTML = `<h1>Subscription tiers</h1><div id="x">Загрузка…</div>`;
  const creditToUsd = await reload(el);

  el.insertAdjacentHTML("beforeend", `
    <div class="card" style="margin-top:20px;max-width:560px">
      <h2 style="margin-top:0">Новый тариф</h2>
      <form class="row" id="newf" style="flex-direction:column;align-items:stretch;gap:10px">
        <input name="name" placeholder="Имя (например 'Pro')" required/>
        <input name="id" placeholder="ID (опционально, например 'pro')"/>
        <label><span style="color:#7b8499">Цена в TON:</span>
          <input name="price_ton" type="number" step="0.1" value="5"/></label>
        <label><span style="color:#7b8499">Кредитов (<span id="new-credit-usd"></span>):</span>
          <input id="new-tier-credits" name="credits" type="number" value="25000"/></label>
        <label><span style="color:#7b8499">Срок в днях:</span>
          <input name="days" type="number" value="30"/></label>
        <label><span style="color:#7b8499">MCP requests:</span>
          <input name="mcp_requests_limit" type="number" min="0" value="10"/></label>
        <label><span style="color:#7b8499">MCP window, sec:</span>
          <input name="mcp_window_seconds" type="number" min="1" value="60"/></label>
        <button>Создать</button>
      </form>
    </div>
  `);
  const newCredits = el.querySelector<HTMLInputElement>("#new-tier-credits")!;
  const newCreditUsd = el.querySelector<HTMLElement>("#new-credit-usd")!;
  const updateNewCreditUsd = () => {
    newCreditUsd.textContent = formatUsd(Number(newCredits.value), creditToUsd);
  };
  newCredits.addEventListener("input", updateNewCreditUsd);
  updateNewCreditUsd();
  (el.querySelector<HTMLFormElement>("#newf"))!.addEventListener("submit", async e => {
    e.preventDefault();
    const form = e.target as HTMLFormElement;
    const fd = new FormData(form);
    try {
      await api.createTier({
        name: fd.get("name"),
        id: fd.get("id") || undefined,
        price_ton: Number(fd.get("price_ton")),
        credits: Number(fd.get("credits")),
        days: Number(fd.get("days")),
        mcp_requests_limit: Math.max(0, Number(fd.get("mcp_requests_limit") || 0)),
        mcp_window_seconds: Math.max(1, Number(fd.get("mcp_window_seconds") || 1)),
      });
      form.reset();
      updateNewCreditUsd();
      await reload(el);
    } catch (err: any) { alert(err.message); }
  });
}

async function reload(el: HTMLElement): Promise<number> {
  const { tiers, free_mcp_limits: free, credit_to_usd: creditToUsd } = await api.tiers();
  const table = `
    <div class="card" style="margin-bottom:16px;max-width:620px">
      <h2 style="margin-top:0">Free MCP: дневной API-бюджет</h2>
      <form class="row" id="free-mcp-limits">
        <label>Кредитов / 24 ч <input name="daily_credits" type="number" min="0" value="${free.daily_credits}" style="width:100px"/></label>
        <button>Save</button>
      </form>
      <p class="meta">0 = без лимита. Один tools/call или legacy API-запрос расходует 1 кредит. initialize и tools/list бесплатны. Бюджет считается за скользящие 24 часа.</p>
    </div>
    <p class="meta"><b>Premium MCP req limit</b> — максимум запросов за указанное окно. <b>Window, sec</b> — длина окна rate limit. Значение 0 у req limit означает unlimited.</p>
    <div class="table-wrap"><table>
      <thead><tr>
        <th>ID</th><th>Name</th><th>Price TON</th><th>Credits (USD)</th>
        <th>Days</th><th>MCP req limit</th><th>Window, sec</th><th>Active</th><th></th>
      </tr></thead>
      <tbody>${tiers.map(t => `
        <tr data-id="${t._id}">
          <td><code>${t._id}</code></td>
          <td><input data-f="name" value="${esc(t.name)}"/></td>
          <td><input data-f="price_ton" type="number" step="0.1" value="${t.price_ton}" style="width:80px"/></td>
          <td><input data-f="credits" type="number" value="${t.credits}" style="width:90px"/><div class="meta" data-credit-usd>(${formatUsd(t.credits, creditToUsd)})</div></td>
          <td><input data-f="days" type="number" value="${t.days}" style="width:70px"/></td>
          <td><input data-f="mcp_requests_limit" type="number" min="0" value="${t.mcp_requests_limit ?? 10}" style="width:85px"/></td>
          <td><input data-f="mcp_window_seconds" type="number" min="1" value="${t.mcp_window_seconds ?? 60}" style="width:100px"/></td>
          <td><input data-f="is_active" type="checkbox" ${t.is_active ? "checked" : ""}/></td>
          <td><button data-save="${t._id}">Save</button></td>
        </tr>`).join("")}
      </tbody>
    </table></div>`;
  el.querySelector("#x")!.innerHTML = table;
  el.querySelector<HTMLFormElement>("#free-mcp-limits")!.addEventListener("submit", async event => {
    event.preventDefault();
    const fd = new FormData(event.currentTarget as HTMLFormElement);
    await api.patchFreeMcpLimits({
      daily_credits: Math.max(0, Number(fd.get("daily_credits") || 0)),
    });
    await reload(el);
  });
  el.querySelectorAll<HTMLInputElement>('input[data-f="credits"]').forEach(input => {
    input.addEventListener("input", () => {
      const amount = input.closest("td")!.querySelector<HTMLElement>("[data-credit-usd]")!;
      amount.textContent = "(" + formatUsd(Number(input.value), creditToUsd) + ")";
    });
  });
  el.querySelectorAll<HTMLButtonElement>("button[data-save]").forEach(b => {
    b.addEventListener("click", async () => {
      const tr = b.closest("tr")!;
      const tierId = b.dataset.save!;
      const inputs = tr.querySelectorAll<HTMLInputElement>("input[data-f]");
      const body: any = {};
      inputs.forEach(i => {
        const f = i.dataset.f!;
        body[f] = i.type === "checkbox" ? i.checked :
                  i.type === "number" ? Number(i.value) : i.value;
      });
      try {
        await api.patchTier(tierId, body);
        b.textContent = "✓"; setTimeout(() => (b.textContent = "Save"), 1500);
      } catch (e: any) { alert(e.message); }
    });
  });
  return creditToUsd;
}

function formatUsd(credits: number, rate: number): string {
  return "$" + (Number(credits || 0) * Number(rate || 0)).toFixed(2);
}

function esc(s: any): string {
  return String(s ?? "").replace(/[&<>"']/g, c => ({"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#39;"}[c]!));
}
